module.exports = __webpack_public_path__ + "static/media/macOS-paste.a67152bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/macOS-paste.svg
// module id = 88
// module chunks = 0